import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
} from 'react-bootstrap';

import BidsetsTable from './BidsetsTable';
import BidsetsTableDetached from './BidsetsTableDetached';
import ManageBidsMenu from './ManageBidsMenu';
import ManageBidRoutesList from './ManageBidRoutesList';
import LocationBidsetsTable from './LocationBidsetsTable';

function findEvent(value) {
  return value.id == this;
}

function showPrefs(groups) {
  for (let i = 0, len = groups.length; i < len; i++) {
    if (!groups[i].hotel_prefs.has_search_prefs) {
      return true;
    }
  }
  return false;
}

class ManageBids extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpdate: false,
      showView:false,
      show: false,
      showManageBids:false,
      parent:false,
      event:null,
      routeId:null,
    };
    this.setCurrentEvent = this.setCurrentEvent.bind(this);
    this.handleClosePrefs = this.handleClosePrefs.bind(this);
    this.handleShowPrefs = this.handleShowPrefs.bind(this);
    this.handleRefreshRequest = this.handleRefreshRequest.bind(this);
    this.showUpdate = this.showUpdate.bind(this);
    this.closeUpdate = this.closeUpdate.bind(this);

    this.changeShowView = this.changeShowView.bind(this);
    this.setCurrentEvent = this.setCurrentEvent.bind(this);
    this.handleClosePrefs = this.handleClosePrefs.bind(this);
    this.handleShowPrefs = this.handleShowPrefs.bind(this);
  }
  componentWillMount() {
    if (this.props.needFetch) {
      this.props.requestBidsets(this.props.tourId);
    }
    this.setState({ show: showPrefs(this.props.tour.groups) });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.detailTab !== this.props.detailTab) {
      this.props.requestBidsets(nextProps.tourId);
    } else if (nextProps.needFetch) {
      this.props.requestBidsets(nextProps.tourId);
    }
    if (nextProps.selectedEvent !== this.props.selectEvent) {
      const event = nextProps.tour.tour_stops.find(findEvent, nextProps.selectedEvent);
      this.setState({ event });
    }
  }
  handleRefreshRequest(e) {
    this.props.requestBidsets(this.props.tourId);
  }
  closeUpdate() {
    this.setState({
      showUpdate: false,
    });
  }
  showUpdate(e) {
    e.preventDefault();
    this.setState({
      showUpdate: true,
    });
  }
  changeShowView(){
    if(this.state.showView==false){
      this.setState({showView:true})
    } else{
      this.setState({
        showView:false,
        showManageBids:false,
      })
    }
  }
  setCurrentEvent(id) {
    this.props.selectEvent(id);
    this.setState({
      showManageBids:true,
      parent:id,
      routeId:id,
    });
  }
  handleClosePrefs() {
    this.setState({ show: false });
  }
  handleShowPrefs() {
    this.setState({ show: true });
  }
  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return (<div>Loading...</div>);
    }

    if (this.props.bids.length !== 0) {
      return (
        <div>
          <ManageBidsMenu
            id={this.props.tour.id}
            bidFilterSet={this.props.bidFilterSet}
            downloadTourPdf={this.props.downloadTourPdf}
            filter={this.props.bidFilter}
            groups={this.props.tour.groups}
            isTourManager={this.props.isTourManager}
            messageSet={this.props.messageSet}
            readOnly={this.props.readOnly}
            sendToTourManager={this.props.sendToTourManager}
            setTourManagerSimMode={this.props.setTourManagerSimMode}
            showUpdate={this.showUpdate}
            tour={this.props.tour}
            user={this.props.user}
            saveAddBookingData={this.props.saveAddBookingData}
            showView={this.state.showView}
            changeShowView={this.changeShowView}
          />
          {this.state.showView?(
            <ManageBidRoutesList
              routes={this.props.tour.tour_stops}
              selectedRoute={this.state.event}
              selectRoute={this.setCurrentEvent}
              showPrefs={this.handleShowPrefs}
              selectedEvent={this.state.event}
              routeId={this.state.routeId}
            />
          ):(
            <BidsetsTable
              bids={this.props.bids}
              proposals={this.props.proposals}
              addBidNote={this.props.addBidNote}
              detail={this.props.detail}
              editBid={this.props.editBid}
              editGroup={this.props.editGroup}
              filter={this.props.bidFilter}
              isTourManager={this.props.isTourManager}
              readOnly={this.props.readOnly}
              removeBid={this.props.removeBid}
              sendBid={this.props.sendBid}
              sendHotelBidRequests={this.props.sendHotelBidRequests}
              user={this.props.user}
              showUpdate={this.state.showUpdate}
              sendBidUpdate={this.props.sendBidUpdate}
              closeUpdate={this.closeUpdate}
              tourData={this.props.tour}
              editMember={this.props.editMember}
              requestBidDetails={this.props.requestBidDetails}
              bidbidsDetails={this.props.bidbidsDetails}
              updateReOpenBid={this.props.updateReOpenBid}
              requestBidsets={this.props.requestBidsets}
              requestAnswers={this.props.requestAnswers}
              answers={this.props.answers}
              ChangeBidDetail={this.props.ChangeBidDetail}
              changeBidDateDetail={this.props.changeBidDateDetail}
              editGroupEventOnManageBid={this.props.editGroupEventOnManageBid}
              dispatchRemoveMemberFromManageBid={this.props.dispatchRemoveMemberFromManageBid}
              changeDateRoomType={this.props.changeDateRoomType}
              addParticipantManageBid={this.props.addParticipantManageBid}
            />
          )}
          {this.state.showManageBids &&(
          <LocationBidsetsTable
            bids={this.props.bids}
            addBidNote={this.props.addBidNote}
            detail={this.props.detail}
            editBid={this.props.editBid}
            editGroup={this.props.editGroup}
            filter={this.props.bidFilter}
            isTourManager={this.props.isTourManager}
            readOnly={this.props.readOnly}
            removeBid={this.props.removeBid}
            sendBid={this.props.sendBid}
            sendHotelBidRequests={this.props.sendHotelBidRequests}
            user={this.props.user}
            showUpdate={this.state.showUpdate}
            sendBidUpdate={this.props.sendBidUpdate}
            closeUpdate={this.closeUpdate}
            tourData={this.props.tour}
            editMember={this.props.editMember}
            requestBidDetails={this.props.requestBidDetails}
            bidbidsDetails={this.props.bidbidsDetails}
            updateReOpenBid={this.props.updateReOpenBid}
            requestBidsets={this.props.requestBidsets}
            requestAnswers={this.props.requestAnswers}
            answers={this.props.answers}
            parent={this.state.parent}
            ChangeBidDetail={this.props.ChangeBidDetail}
            changeBidDateDetail={this.props.changeBidDateDetail}
            editGroupEventOnManageBid={this.props.editGroupEventOnManageBid}
            dispatchRemoveMemberFromManageBid={this.props.dispatchRemoveMemberFromManageBid}
            changeDateRoomType={this.props.changeDateRoomType}
            addParticipantManageBid={this.props.addParticipantManageBid}
          />)}
        </div>
      );
    }
    return (
      <div>No bids are available. You must select hotels before managing bids.
        <Button onClick={this.handleRefreshRequest} bsStyle="primary">Refresh</Button>
      </div>
    );
  }
}

ManageBids.propTypes = {
  tourId: PropTypes.number.isRequired,
  addBidNote: PropTypes.func.isRequired,
  bidFilter: PropTypes.object.isRequired,
  bidFilterSet: PropTypes.func.isRequired,
  bids: PropTypes.arrayOf(PropTypes.object).isRequired,
  detail: PropTypes.string,
  editBid: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  needFetch: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  removeBid: PropTypes.func.isRequired,
  requestBidsets: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  sendBidUpdate: PropTypes.func.isRequired,
  sendToTourManager: PropTypes.func.isRequired,
  saveAddBookingData: PropTypes.func.isRequired,
};

ManageBids.defaultProps = {
  bids: [],
  detail: null,
};
export default ManageBids;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBids.js